import { useNavigate, useParams } from "react-router-dom";
import { UrlPath } from "../../../../config/routeConfig";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs"
import { TopBar } from "../../../shared/topBar/TopBar"
import { getCumulativeReturnsChart, getDistReturnsChart, getReturnsGrid, getThirdPartyDataAPI, getreturnschart } from "../../../../config/apiConfig";
import { exportToExcelUsingRef } from "../../../utils/excelExporter";
import { useState } from "react";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { useEffect } from "react";
import download from '../../../../Images/download.svg';
import burgerIcon from '../../../../Images/burgerIcon.svg';
import chartIcon from '../../../../Images/chartIcon.svg';
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { Chart, ChartLegend, ChartTitle, ChartCategoryAxis, ChartCategoryAxisItem, ChartValueAxis, ChartValueAxisItem, ChartSeries, ChartSeriesItem } from '@progress/kendo-react-charts';
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getThirdPartyDataDetailsDetailAction } from "../../../actions/ThirdPartyDataAction";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";


export const ThirdPartyDataAnalytics = () => {

    const { EntityId } = useParams();
    const dispatch = useDispatch();
    const history = useNavigate();
    const [thirdPartyList, setThirdPartyList] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [selectedView, setSelectedView] = useState("Grid");
    const [selectedChart, setSelectedChart] = useState("CUMM");
    const [selectedYear, setSelectedYear] = useState(0);
    const [returnsData, setReturnsData] = useState({});
    const [cumulativeChartData, setCumulativeChartData] = useState({});
    const [distChartData, setDistChartData] = useState({});
    const [chartData, setChartData] = useState({});
    const [thirdPartyData, setThirdPartyData] = useState(null);

    const chartOptions = ['CUMM', 'DISTR', 'Rolling', 'VAMI'];
    const ref = useRef();
    const CurrentThirdPartyData = useSelector(state => state.ThirdPartyData.ThirdPartyDetails) || {};
    useEffect(() => {
        setThirdPartyData(val => CurrentThirdPartyData);

    }, [CurrentThirdPartyData])

    const currentPortfolio = useSelector(state => state.portfolio.portfolio) || {};
    const portfolioID=currentPortfolio.PortfolioId || 2537; 
    useEffect(() => {
        setThirdPartyRowDataFromAPI();
        document.title = "Third Party Data Analytics"
    }, []);
    useEffect(() => {
        if (EntityId && thirdPartyList.length > 0) {
            const entity = thirdPartyList.find(item => item.CustomEntityId == EntityId);
            setSelectedEntity(entity || null);
            dispatch(getThirdPartyDataDetailsDetailAction({ Id: EntityId, ThirdPartyDataDetails: entity }));
            getReturnsDataFortheSelectedDateRange(4)
            getReturnsChartFortheSelectedDateRange(4)
            setSelectedYear(0);
        } else {
            setSelectedEntity(null);
        }
    }, [EntityId, thirdPartyList]);

    const setThirdPartyRowDataFromAPI = async () => {
        const data = await fetchThirdPartyRowData();
        setThirdPartyList(data);
    };

    const fetchThirdPartyRowData = async () => {
        try {
            return await sbaAxios({ url: getThirdPartyDataAPI });
        } catch (error) {
            console.error("Failed to fetch third party data", error);
            return [];
        }
    };

    const Level = [
        { BreadCrumb: "Portfolio >", Routes: `/${UrlPath.PortfolioList}` },
        { BreadCrumb: "Third Party Data >", Routes: `${UrlPath.PThirdPartyData}${portfolioID}` },
        { BreadCrumb: "Analytics", Routes: `${UrlPath.PThirdPartyDataAnalytics}${EntityId}` },
    ];



    const handleEntityOnChange = (e) => {
        if (e.value) {
            history(`${UrlPath.ThirdPartyDataDetails}${e.value.CustomEntityId}`);
        }
    }

    const fetchReturnsDataFortheSelectedDateRange = async (option) => {
        try {
            const date = new Date().toISOString();
            const url = `${getReturnsGrid}${EntityId},${10},${date},${date},${option}`;
            const resultData = await sbaAxios({ url });
            return resultData;
        } catch (error) {

        }
    };

    const fetchReturnsChartFortheSelectedDateRange = async (option) => {
        try {
            const date = new Date().toISOString();
            const url = `${getreturnschart}${EntityId},${10},${date},${date},${option}`;

            const resultData = await sbaAxios({ url });
            return resultData;
        } catch (error) {
            return null;
        }
    };

    const fetchReturnsCumulativeChartFortheSelectedDateRange = async (option) => {
        try {
            const date = new Date().toISOString();
            const url = `${getCumulativeReturnsChart}${EntityId},${10},${date},${date},${option}`;

            const resultData = await sbaAxios({ url });
            return resultData;
        } catch (error) {
            return null;
        }
    };

    const fetchReturnsDistChartDataChartFortheSelectedDateRange = async (option) => {
        try {
            const date = new Date().toISOString();
            const url = `${getDistReturnsChart}${EntityId},${10},${date},${date},${option}`;
            const resultData = await sbaAxios({ url });
            return resultData;
        } catch (error) {
            return null;
        }
    };
    const getReturnsDataFortheSelectedDateRange = async (option) => {
        try {
            const returnsData = await fetchReturnsDataFortheSelectedDateRange(option);
            setReturnsData(val => returnsData);
            const cumulativeChartData = await fetchReturnsCumulativeChartFortheSelectedDateRange(option);
            setCumulativeChartData(val => cumulativeChartData);
            const distChartData = await fetchReturnsDistChartDataChartFortheSelectedDateRange(option);
            setDistChartData(val => distChartData);
        } catch (error) {
            setReturnsData(val => { })
        }
    };
    const getReturnsChartFortheSelectedDateRange = async (option) => {
        try {
            const returnsData = await fetchReturnsChartFortheSelectedDateRange(option)
            setChartData(val => returnsData);
        } catch (error) {
            setChartData(val => { })
        }
    };
    const defaultColDef = {
        wrapHeaderText: true,
        autoHeaderHeight: true, resizable: true, sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter', minWidth: 100
    };


    const Grid = returnsData?.ReturnsGrid?.map(item => {
        const Jan = (item.Months[0].ReturnValue !== null) ? (item.Months[0].ReturnValue * 100).toFixed(2) : '';
        const Feb = (item.Months[1].ReturnValue !== null) ? (item.Months[1].ReturnValue * 100).toFixed(2) : '';
        const Mar = (item.Months[2].ReturnValue !== null) ? (item.Months[2].ReturnValue * 100).toFixed(2) : '';
        const Apr = (item.Months[3].ReturnValue !== null) ? (item.Months[3].ReturnValue * 100).toFixed(2) : '';
        const May = (item.Months[4].ReturnValue !== null) ? (item.Months[4].ReturnValue * 100).toFixed(2) : '';
        const Jun = (item.Months[5].ReturnValue !== null) ? (item.Months[5].ReturnValue * 100).toFixed(2) : '';
        const Jul = (item.Months[6].ReturnValue !== null) ? (item.Months[6].ReturnValue * 100).toFixed(2) : '';
        const Aug = (item.Months[7].ReturnValue !== null) ? (item.Months[7].ReturnValue * 100).toFixed(2) : '';
        const Sep = (item.Months[8].ReturnValue !== null) ? (item.Months[8].ReturnValue * 100).toFixed(2) : '';
        const Oct = (item.Months[9].ReturnValue !== null) ? (item.Months[9].ReturnValue * 100).toFixed(2) : '';
        const Nov = (item.Months[10].ReturnValue !== null) ? (item.Months[10].ReturnValue * 100).toFixed(2) : '';
        const Dec = (item.Months[11].ReturnValue !== null) ? (item.Months[11].ReturnValue * 100).toFixed(2) : '';
        const YTD = (item.YTD !== null) ? (item.YTD * 100).toFixed(2) : '';
        return {
            Year: item?.Year,
            Jan: Jan,
            Feb: Feb,
            Mar: Mar,
            Apr: Apr,
            May: May,
            Jun: Jun,
            Jul: Jul,
            Aug: Aug,
            Sep: Sep,
            Oct: Oct,
            Nov: Nov,
            Dec: Dec,
            YTD: YTD,
        }
    })
    const columnDefs = [
        { field: "Year", headerName: "Year", width: 130, cellStyle: { color: '#00609E' }, sort: "desc" },
        {
            field: "Jan", headerName: "Jan", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Feb", headerName: "Feb", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Mar", headerName: "Mar", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Apr", headerName: "Apr", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "May", headerName: "May", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Jun", headerName: "Jun", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Jul", headerName: "Jul", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Aug", headerName: "Aug", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Sep", headerName: "Sep", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Oct", headerName: "Oct", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Nov", headerName: "Nov", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "Dec", headerName: "Dec", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : '' })
        },
        {
            field: "YTD", headerName: "YTD", width: 130,
            valueFormatter: ({ value }) => (value >= 0 && value !== "") ? `+${value}%` : (value <= 0 && value !== "") ? `${value}%` : '',
            cellStyle: ({ value }) => ({ color: (value < 0) ? 'red' : 'green' })
        },
    ];



    return <>
        <TopBar label={"Third Party Data"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="p-2">
                {thirdPartyData?.ThirdPartyDetailsLoading ? <><LoadingScreen /></> : <>
                    <div className="detail bg-white p-4">
                        <div className="row gap-3">
                            <div className="col-md-4 col-lg-4">
                                <label htmlFor="select fund" className="mb-1 label">
                                    Select Entity
                                </label>
                                <div className="DropDownDiv input-border">
                                    <SBAComboBox
                                        filterable={true}
                                        data={thirdPartyList}
                                        textField={"CustomEntityName"}
                                        valueField={"CustomEntityId"}
                                        value={selectedEntity}
                                        onChange={(e) => { handleEntityOnChange(e) }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="detail bg-white p-4">
                        <div className="d-flex my-4">
                            <button
                                className={`toggle-btn rounded-start ${selectedView == "Grid" && "active"
                                    }`}
                                onClick={() => {
                                    setSelectedView(val => "Grid")
                                }}
                            >
                                <span>
                                    <img
                                        src={burgerIcon}
                                        alt=""
                                        style={{
                                            filter: selectedView == "Grid"
                                                ? "brightness(100%)"
                                                : "brightness(50%)",
                                        }}
                                    />
                                </span>
                                Grid View
                            </button>
                            <button
                                className={`toggle-btn rounded-end ${selectedView == "Chart" && "active"
                                    }`}
                                onClick={() => {
                                    setSelectedView(val => "Chart")
                                }}
                            >
                                <span>
                                    <img
                                        src={chartIcon}
                                        alt=""
                                        style={{
                                            filter: selectedView == "Chart"
                                                ? "brightness(100%)"
                                                : "brightness(50%)",
                                        }}
                                    />
                                </span>
                                Chart View
                            </button>
                            <div className="YearRG d-flex gap my-auto" id="Mkdiv">
                                <span className="radioSelectorGroup SBA_hand">
                                    <div>
                                        <span
                                            className={
                                                selectedYear === 1
                                                    ? "selected YearRadioSpan"
                                                    : "YearRadioSpan"
                                            }
                                            onClick={() => {
                                                setSelectedYear(1)
                                                getReturnsDataFortheSelectedDateRange(0)
                                                getReturnsChartFortheSelectedDateRange(0)
                                            }}
                                        >
                                            1Y
                                        </span>
                                    </div>
                                    <div>
                                        <span
                                            className={
                                                selectedYear === 3
                                                    ? "selected YearRadioSpan"
                                                    : "YearRadioSpan"
                                            }
                                            onClick={() => {
                                                setSelectedYear(3)
                                                getReturnsDataFortheSelectedDateRange(1)
                                                getReturnsChartFortheSelectedDateRange(1)

                                            }}
                                        >
                                            3Y
                                        </span>
                                    </div>
                                    <div>
                                        <span
                                            className={
                                                selectedYear === 5
                                                    ? "selected YearRadioSpan"
                                                    : "YearRadioSpan"
                                            }
                                            onClick={() => {
                                                setSelectedYear(5)
                                                getReturnsDataFortheSelectedDateRange(2)
                                                getReturnsChartFortheSelectedDateRange(2)

                                            }}
                                        >
                                            5Y
                                        </span>
                                    </div>
                                    <div>
                                        <span
                                            className={
                                                selectedYear === 10
                                                    ? "selected YearRadioSpan"
                                                    : "YearRadioSpan"
                                            }
                                            onClick={() => {
                                                setSelectedYear(10)
                                                getReturnsDataFortheSelectedDateRange(3)
                                                getReturnsChartFortheSelectedDateRange(3)

                                            }}
                                        >
                                            10Y
                                        </span>
                                    </div>
                                    <div>
                                        <span
                                            className={
                                                selectedYear === 0
                                                    ? "selected YearRadioSpan"
                                                    : "YearRadioSpan"
                                            }
                                            onClick={() => {
                                                setSelectedYear(0)
                                                getReturnsDataFortheSelectedDateRange(4)
                                                getReturnsChartFortheSelectedDateRange(4)

                                            }}
                                        >
                                            ITD
                                        </span>
                                    </div>
                                    <div>

                                    </div>
                                </span>
                            </div>
                            {selectedView == 'Grid' && <div className="ms-auto">
                                <button type="button" className="p-sm-btn mx-1" onClick={() => { exportToExcelUsingRef(ref, selectedEntity?.CustomEntityName + ".xlsx") }}><img src={download} alt="Excel" />Export</button>
                            </div>}
                            {selectedView == 'Chart' && <div className="ms-auto">
                                {chartOptions.map((option, index) => {
                                    return <button
                                        key={option + index}
                                        value={option}
                                        className={`non-gappable-button ${selectedChart === option
                                            ? "selected-non-gappable-button"
                                            : ""
                                            }`}
                                        onClick={() => { setSelectedChart(option) }}
                                    >
                                        {option}
                                    </button>
                                })}
                            </div>}
                        </div>


                        {selectedView == "Grid" && <>
                            <div className="ag-theme-alpine" style={{ width: '100%', height: '700px' }}>
                                <AgGridReact
                                    ref={ref}
                                    columnDefs={columnDefs}
                                    rowData={Grid}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    paginationPageSize={20}
                                    rowSelection="Single"
                                />
                            </div>
                        </>}
                        {selectedView == "Chart" && <>

                            {selectedChart == "VAMI" &&
                                <div className="ag-theme-alpine w-100" >
                                    <VamiChart vamiChartData={chartData}
                                    />
                                </div>}
                            {selectedChart == "CUMM" &&

                                <div className="ag-theme-alpine w-100" >
                                    <CumulativeReturnsChart cumlativeChart={cumulativeChartData}
                                    />
                                </div>}
                            {selectedChart == "DISTR" &&

                                <div className="ag-theme-alpine w-100" >
                                    <DistReturnsChart distChartData={distChartData}
                                    />
                                </div>}
                            {selectedChart == "Rolling" &&

                                <div className="ag-theme-alpine w-100" >
                                   <p className="text-danger text-center">No Data Found</p>
                                </div>}
                        </>}

                    </div>
                </>}

            </div>

        </div>
    </>
}


const VamiChart = ({ vamiChartData }) => {
    const [minMaxGrowth, setGrowthof1000] = useState([]);
    const [postiveNegativeReturn, setPostiveNegativeReturns] = useState([]);
    const [chartStepValue, setChartStepValue] = useState(-2);

    const vammiChart = vamiChartData || [];
    const getChartValues = () => {
        const Growthof1000Value = vammiChart.GrowthOf1000 || [];
        const PostiveNegative = vammiChart.PostiveNegative || [];
        setGrowthof1000(() => Growthof1000Value);
        setPostiveNegativeReturns(() => PostiveNegative);
        if (vammiChart?.GrowthOf1000?.length > 120)
            setChartStepValue(10)
        else if (vammiChart?.GrowthOf1000?.length > 60)
            setChartStepValue(2)
        else
            setChartStepValue(1)
    };
    useEffect(() => {
        getChartValues();
    }, [vammiChart])

    const rorValues = minMaxGrowth.map((item) => item.ROR) || [];
    const posNegRor = postiveNegativeReturn.map((item) => ({
        value: item.ReturnValue,
    })) || [];
    const pointLength = posNegRor.length + 1;
    const posRor = postiveNegativeReturn.map((item) => ({
        value: item.ReturnValue > 0 ? (item.ReturnValue) : 0,
    })) || [];
    const negRor = postiveNegativeReturn.map((item) => ({
        value: item.ReturnValue < 0 ? (item.ReturnValue) : 0,
    })) || [];
    const uniqueCategories = postiveNegativeReturn.map((item) => moment(item.PriceDate).format('MMM YYYY')) || [];

    return <>
        <div style={{ height: '0px' }}>

            <svg xmlns="https://www.w3.org/2000/svg" version="1.1" style={{ width: '0', height: '0', visibility: 'hidden' }}>
                <defs>
                    <linearGradient id="svg-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="100%" style={{ stopColor: '#C2EAE2' }} />
                        <stop offset="0%" style={{ stopColor: '#FFFFFF' }} />
                    </linearGradient>
                </defs>
            </svg>
        </div>
        <div style={{ width: '100%', height: '400px' }}>
            <Chart>
                <ChartTitle />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem
                        categories={uniqueCategories}
                        title={{ visible: false }}
                        line={{ visible: false }}
                        labels={{
                            step: chartStepValue,
                            rotation: 90,
                            position: 'start'
                        }}
                        justified={true}
                        majorGridLines={{ visible: false }}
                        axisCrossingValue={[0, pointLength, pointLength, 0]}
                        color="#7D7D7D"
                    />
                </ChartCategoryAxis>
                <ChartSeries>
                    <ChartSeriesItem
                        type="column"
                        data={posRor}
                        field="value"
                        justified={true}
                        color='#05BFDB'
                        markers={{ visible: false }}
                        tooltip={{ visible: true, format: `{0:p2}` }}
                        axis="primary"
                        name="Positive Returns" />
                    <ChartSeriesItem
                        type="column"
                        data={negRor}
                        field="value"
                        justified={true}
                        color='#FF8686'
                        markers={{ visible: false }}
                        tooltip={{ visible: true, format: `{0:p2}` }}
                        axis="primary"
                        name="Negative Returns" />
                    <ChartSeriesItem
                        type="area"
                        className="custom-series"
                        data={rorValues}
                        justified={true}
                        markers={{ visible: false }}
                        tooltip={{ visible: true, format: `{0:c0}` }}
                        axis="secondary"
                        opacity={0.3}
                        color="url(#svg-gradient)"
                    />
                    <ChartSeriesItem
                        type="line"
                        className="custom-series"
                        data={rorValues}
                        justified={true}
                        color="#1B9C85"
                        markers={{ visible: false }}
                        tooltip={{ visible: true, format: `{0:c0}` }}
                        axis="secondary"
                        stroke="#1B9C85"
                        fill="#1B9C85"
                        style={{ border: "2px solid #1B9C85" }}
                        name="Growth of 1000"
                    />
                </ChartSeries>
                <ChartLegend position="bottom" visible={true} />
                <ChartValueAxis>
                    <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0:p0}', position: 'right' }} majorGridLines={{ visible: false }} />
                    <ChartValueAxisItem name="secondary" color="#7D7D7D" labels={{ format: '{0:c0}' }} line={{ visible: true, axis: 'right' }} majorGridLines={{ visible: false }} />
                </ChartValueAxis>
            </Chart>

        </div>
    </>
}


const CumulativeReturnsChart = ({ cumlativeChart }) => {
    const [entityReturns, setEntityReturns] = useState([]);
    const [bM1Returns, setBM1Returns] = useState([]);
    const [bM2Returns, setBM2Returns] = useState([]);
    const [returnDate, setReturnDate] = useState([]);
    const [cumulativeChartStepValue, setCumulativeChartStepValue] = useState(-2);
    const getChartdata = () => {
        setEntityReturns(() => cumlativeChart?.EntityReturns);
        setBM1Returns(() => cumlativeChart?.BM1Returns);
        setBM2Returns(() => cumlativeChart?.BM2Returns);
        setReturnDate(() => cumlativeChart?.EntityReturns?.map((item) => moment(item.ReturnDate).format('MMM YYYY')) || []);
        if (cumlativeChart?.EntityReturns?.length > 120)
            setCumulativeChartStepValue(10);
        else if (cumlativeChart?.EntityReturns?.length > 60)
            setCumulativeChartStepValue(2);
        else
            setCumulativeChartStepValue(1);
    };
    useEffect(() => {
        getChartdata();
    }, [cumlativeChart]);
    const entityReturnsValue = entityReturns?.map((item) => (item.ReturnValue * 100)) || [];
    const bM1ReturnsValue = bM1Returns?.map((item) => (item.ReturnValue * 100)) || [];
    const bM2ReturnsValue = bM2Returns?.map((item) => (item.ReturnValue * 100)) || [];

    return (
        <>
            <div style={{ width: '100%', height: '400px' }}>
                <Chart>
                    <ChartTitle />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            categories={returnDate}
                            title={{ visible: false }}
                            line={{ visible: false }}
                            labels={{
                                step: cumulativeChartStepValue,
                                rotation: 310,
                                position: 'start'
                            }}
                            justified={true}
                            majorGridLines={{ visible: false }}
                            color="#7D7D7D"
                        />
                    </ChartCategoryAxis>
                    <ChartSeries>
                        <ChartSeriesItem
                            type="line"
                            data={entityReturnsValue}
                            field="value"
                            justified={true}
                            color='#1B9C85'
                            markers={{ visible: false }}
                            tooltip={{ visible: true, format: `{0:n2}` }}
                            axis="primary"
                            name={entityReturns && entityReturns[0] && entityReturns[0].EntityName}
                        />
                        <ChartSeriesItem
                            type="line"
                            data={bM1ReturnsValue}
                            field="value"
                            justified={true}
                            color='#05BFDB'
                            markers={{ visible: false }}
                            tooltip={{ visible: true, format: `{0:n2}` }}
                            axis="primary"
                            name={bM1Returns && bM1Returns[0] && bM1Returns[0].EntityName}
                        />
                        <ChartSeriesItem
                            type="line"
                            data={bM2ReturnsValue}
                            field="value"
                            justified={true}
                            color='#FF8686'
                            markers={{ visible: false }}
                            tooltip={{ visible: true, format: `{0:n2}` }}
                            axis="primary"
                            name={bM2Returns && bM2Returns[1] && bM2Returns[0].EntityName}
                        />
                    </ChartSeries>
                    <ChartLegend position="bottom" visible={true} />
                    <ChartValueAxis>
                        <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0}%', position: 'right' }} majorGridLines={{ visible: false }} />
                    </ChartValueAxis>
                </Chart>
            </div>
        </>
    )
}



const DistReturnsChart = ({ distChartData }) => {
    const [entityReturns, setEntityReturns] = useState([]);
    const [bM1Returns, setBM1Returns] = useState([]);
    const [bM2Returns, setBM2Returns] = useState([]);
    const [bmRange, setBMRange] = useState([]);
    const getChartData = () => {
        const EntityReturns = distChartData?.EntityReturns || [];
        const BM1Returns = distChartData?.BM1Returns || [];
        const BM2Returns = distChartData?.BM2Returns || [];
        const BMRange = EntityReturns?.map((item) => item.BenchmarkRange) || [];
        setEntityReturns(() => EntityReturns);
        setBM1Returns(() => BM1Returns);
        setBM2Returns(() => BM2Returns);
        setBMRange(() => BMRange);
    }


    useEffect(() => {
        getChartData();
    }, [distChartData]);

    const entityReturnsValue = entityReturns?.map((item) => (item.MonthlyReturnCount)) || [];
    const bM1ReturnsValue = bM1Returns?.map((item) => (item.MonthlyReturnCount)) || [];
    const bM2ReturnsValue = bM2Returns?.map((item) => (item.MonthlyReturnCount)) || [];

    return (
        <>
            <div style={{ width: '100%', height: '400px' }}>
                <Chart>
                    <ChartTitle />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem
                            categories={bmRange}
                            title={{ visible: false }}
                            line={{ visible: false }}
                            labels={{
                                rotation: 310,
                                position: 'start'
                            }}
                            justified={true}
                            majorGridLines={{ visible: false }}
                            color="#7D7D7D"
                        />
                    </ChartCategoryAxis>
                    <ChartSeries>
                        <ChartSeriesItem
                            type="column"
                            data={entityReturnsValue}
                            field="value"
                            justified={true}
                            color='#1B9C85'
                            markers={{ visible: false }}
                            tooltip={{ visible: true }}
                            axis="primary"
                            name={entityReturns && entityReturns[0] && entityReturns[0].EntityName}
                        />
                        <ChartSeriesItem
                            type="column"
                            data={bM1ReturnsValue}
                            field="value"
                            justified={true}
                            color='#05BFDB'
                            markers={{ visible: false }}
                            tooltip={{ visible: true }}
                            axis="primary"
                            name={bM1Returns && bM1Returns[0] && bM1Returns[0].EntityName}
                        />
                        <ChartSeriesItem
                            type="column"
                            data={bM2ReturnsValue}
                            field="value"
                            justified={true}
                            color='#FF8686'
                            markers={{ visible: false }}
                            tooltip={{ visible: true }}
                            axis="primary"
                            name={bM2Returns && bM2Returns[1] && bM2Returns[0].EntityName}
                        />
                    </ChartSeries>
                    <ChartLegend position="bottom" visible={true} />
                    <ChartValueAxis>
                        <ChartValueAxisItem name="primary" color="#7D7D7D" axisCrossingValue={[0, -100000000000000000, 0, 0]} labels={{ format: '{0}', position: 'right' }} majorGridLines={{ visible: false }} />
                    </ChartValueAxis>
                </Chart>
            </div>
        </>
    )
}